export default "__VITE_ASSET__CLBYHNmC__"